// The few UI texts written in Swedish in the code, translated for English mode.
const dict = {
  "Arbeta i denna organisation": "Work in this organization",
  "Du arbetar i": "You are working in",
  "Du har inte längre tillgång till den här organisationen": "You no longer have access to this organization",
  "Lämna": "Leave",
  "okänd organisation": "unknown organization",
  "Skärmdelning": "Screen sharing",
  "Supportläge": "Support mode",
  "— ändringar sparas på kundens konto": "— changes are saved to the customer's account",
  "⚠ STAGING — testmiljö (staging.app.notiz.se), inte produktion": "⚠ STAGING — test environment (staging.app.notiz.se), not production",
};

export default dict;
